import axios, { AxiosRequestConfig } from 'axios';

import UserCred from '../models/UserCred';
import U from './Utils';
import CSharpUtils from './CSharpUtils';

export const loginToAutodataDotNet = (userCred: UserCred) => {
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/auth/login`,
    maxContentLength: 1000000,
    timeout: 10000,
    headers: {
      'content-type': 'application/json',
      Accept: 'application/json;charset=utf-8',
    },
    data: {
      username: userCred.username,
      password: userCred.password,
    },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

export const autoLoginToAutodataDotNetAPI = (token: string, btsg: string) => {
  const tabId = btsg;
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/auth/refresh`,
    maxContentLength: 1000000,
    timeout: 20000,
    headers: {
      'content-type': 'application/json',
      Accept: 'application/json;charset=utf-8',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    data: {
      token,
      tabId,
    },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

// StepArticle API calls
export const searchStepArticles = (searchRequest: any) => {
  const proxyUrl = `${U.URL_ADDRESS}${U.WEBAPI_PATH}/api/step-articles/search`;
  
  // Debug logging
  console.log('StepArticle API Debug:');
  console.log('URL_ADDRESS:', U.URL_ADDRESS);
  console.log('WEBAPI_PATH:', U.WEBAPI_PATH);
  console.log('Proxy URL:', proxyUrl);
  console.log('Search Request:', searchRequest);
  console.log('Token:', CSharpUtils.Get_Token);
  
  const config = {
    method: 'post',
    baseURL: proxyUrl,
    maxContentLength: 1000000,
    timeout: 20000,
    headers: {
      'content-type': 'application/json',
      Accept: 'application/json;charset=utf-8',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    data: searchRequest,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

export const previewStepArticleUpload = (formData: FormData) => {
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/api/step-articles/preview`,
    maxContentLength: 10000000,
    timeout: 30000,
    headers: {
      'content-type': 'multipart/form-data',
      Accept: 'application/json;charset=utf-8',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    data: formData,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

export const processStepArticleUpload = (formData: FormData) => {
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/api/step-articles/process`,
    maxContentLength: 10000000,
    timeout: 30000,
    headers: {
      'content-type': 'multipart/form-data',
      Accept: 'application/json;charset=utf-8',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    data: formData,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

export const supportLoginImpersonate = (username: string, tabId: string) => {
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/login/impersonate`,
    timeout: 10000,
    headers: {
      'content-type': 'application/json',
      Accept: 'application/json;charset=utf-8',
    },
    data: { username, tabId },
    withCredentials: true,
    responseType: 'json',
    responseEncoding: 'utf8',
  } as AxiosRequestConfig;
  return axios.request(config);
};

